import React from 'react';
import { useApp } from '../context/AppContext';
import { useStageLabel } from '../hooks/useStageLabel';

/**
 * Pill-shaped badge showing the user's current stage (e.g. cycle · stim day · days to retrieval).
 * Pulls data from AppContext; supports demo overrides for signed-out views.
 */
export default function StagePill({
  /** Override label when in demo mode */
  demoLabel,
  /** Override icon when in demo mode */
  demoIcon,
  /** Chapter id for non-IVF fallback (cycle, ttc, pregnancy, etc.) */
  chapter = 'fertility',
  /** Accent color; defaults to primary pink */
  accent = '#D4537E',
  /** Background color; defaults to pale pink */
  background = '#FDF2F5',
  /** Optional click handler */
  onClick,
  style = {},
}) {
  const appData = useApp();
  const { label, icon } = useStageLabel(appData, {
    chapter,
    demoLabel,
    demoIcon,
  });

  const pillStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 11,
    fontWeight: 600,
    padding: '6px 12px',
    borderRadius: 999,
    background,
    color: accent,
    fontFamily: "'Plus Jakarta Sans', -apple-system, sans-serif",
    ...(onClick && { cursor: 'pointer' }),
    ...style,
  };

  return (
    <span
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={onClick ? (e) => e.key === 'Enter' && onClick(e) : undefined}
      style={pillStyle}
    >
      <span style={{ lineHeight: 1 }}>{icon}</span>
      <span>{label}</span>
    </span>
  );
}
